(function () {
  var NAME_NO_DIGITS = /^[^0-9]+$/;
  var HAS_LETTER = /\p{L}/u;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init(form) {
    if (!form || form.dataset.velvetyContactInit === 'true') return;
    form.dataset.velvetyContactInit = 'true';

    var first = form.querySelector('#ContactForm-first');
    var last = form.querySelector('#ContactForm-last');
    var email = form.querySelector('#ContactForm-email');
    var phone = form.querySelector('#ContactForm-phone');
    var body = form.querySelector('#ContactForm-body');
    var submit = form.querySelector('.velvety-contact__submit');

    function setError(input, key, message) {
      var el = form.querySelector('[data-error-for="' + key + '"]');
      if (el) { el.textContent = message; el.hidden = false; }
      if (input) input.setAttribute('aria-invalid', 'true');
    }
    function clearError(input, key) {
      var el = form.querySelector('[data-error-for="' + key + '"]');
      if (el) { el.textContent = ''; el.hidden = true; }
      if (input) input.removeAttribute('aria-invalid');
    }

    function checkName(input, key, label, show) {
      var v = (input.value || '').trim();
      if (!v) {
        if (show) setError(input, key, 'Please enter your ' + label + '.');
        return false;
      }
      if (!NAME_NO_DIGITS.test(v) || !HAS_LETTER.test(v)) {
        if (show) setError(input, key, 'Name cannot contain numbers.');
        return false;
      }
      clearError(input, key);
      return true;
    }
    function checkFirst(show) { return checkName(first, 'first', 'first name', show); }
    function checkLast(show) { return checkName(last, 'last', 'last name', show); }

    function checkEmail(show) {
      var v = (email.value || '').trim();
      if (!v) { if (show) setError(email, 'email', 'Please enter your email address.'); return false; }
      if (!EMAIL_RE.test(v)) { if (show) setError(email, 'email', 'Enter a valid email address, e.g. name@example.com.'); return false; }
      clearError(email, 'email');
      return true;
    }

    function checkPhone(show) {
      var v = (phone.value || '').trim();
      if (!v) { if (show) setError(phone, 'phone', 'Please enter your phone number.'); return false; }
      var digits = v.replace(/[^0-9]/g, '');
      if (digits.length < 6 || digits.length > 15) { if (show) setError(phone, 'phone', 'Enter a valid phone number.'); return false; }
      clearError(phone, 'phone');
      return true;
    }

    function checkBody(show) {
      var v = (body.value || '').trim();
      if (!v) { if (show) setError(body, 'body', 'Please enter a message.'); return false; }
      clearError(body, 'body');
      return true;
    }

    function allValid(show) {
      var ok = true;
      if (!checkFirst(show)) ok = false;
      if (!checkLast(show)) ok = false;
      if (!checkEmail(show)) ok = false;
      if (!checkPhone(show)) ok = false;
      if (!checkBody(show)) ok = false;
      return ok;
    }
    function refresh() { if (submit) submit.disabled = !allValid(false); }

    function bind(input, checkFn) {
      if (!input) return;
      input.addEventListener('input', function () { checkFn(false); refresh(); });
      input.addEventListener('blur', function () { checkFn(true); refresh(); });
    }
    bind(first, checkFirst);
    bind(last, checkLast);
    bind(email, checkEmail);
    bind(phone, checkPhone);
    bind(body, checkBody);

    /* Phone country-code selector — UAE default, GCC first. Combines the
       chosen dial code + the local number into the hidden contact[Phone]. */
    (function initPhone() {
      var wrap = form.querySelector('[data-velvety-phone]');
      if (!wrap) return;
      var toggle = wrap.querySelector('[data-velvety-phone-toggle]');
      var list = wrap.querySelector('[data-velvety-phone-list]');
      var flagEl = wrap.querySelector('[data-velvety-phone-flag]');
      var dialEl = wrap.querySelector('[data-velvety-phone-dial]');
      var hidden = wrap.querySelector('[data-velvety-phone-hidden]');
      var number = wrap.querySelector('[data-velvety-phone-number]');
      if (!toggle || !list || !hidden || !number) return;
      var dial = dialEl ? dialEl.textContent.trim() : '+971';

      function syncHidden() {
        var local = (number.value || '').trim();
        hidden.value = local ? dial + ' ' + local : '';
      }
      function openList(open) {
        if (open) { list.removeAttribute('hidden'); toggle.setAttribute('aria-expanded', 'true'); }
        else { list.setAttribute('hidden', ''); toggle.setAttribute('aria-expanded', 'false'); }
      }
      toggle.addEventListener('click', function () { openList(list.hasAttribute('hidden')); });
      list.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-velvety-phone-option]');
        if (!opt) return;
        dial = opt.getAttribute('data-dial') || dial;
        if (flagEl) flagEl.textContent = opt.getAttribute('data-flag') || '';
        if (dialEl) dialEl.textContent = dial;
        var opts = list.querySelectorAll('[data-velvety-phone-option]');
        for (var i = 0; i < opts.length; i++) opts[i].classList.toggle('is-selected', opts[i] === opt);
        openList(false);
        syncHidden();
        number.focus();
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) openList(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openList(false); });
      number.addEventListener('input', syncHidden);
      form.addEventListener('submit', syncHidden);
      syncHidden();
    })();

    form.addEventListener('submit', function (ev) {
      if (!allValid(true)) {
        ev.preventDefault();
        var firstInvalid = form.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
        return;
      }
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submit.classList.add('is-loading');
      }
    });

    refresh();
  }

  function initAll() {
    var forms = document.querySelectorAll('.velvety-contact__form');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
